import officeStore, { OfficeId } from "~/stores/offices";
import { observer } from "mobx-react";
import AsyncPaginatedSelect from "~/components/AsyncPaginatedCombobox";

interface Props {
  value: OfficeId[];
  onChange: (newValue: OfficeId[]) => void;
  selectProps: any;
}

const OfficeSelect = observer((props: Props) => {
  const fetcher = officeStore.f;
  const idToOpt = (id: OfficeId) => {
    const item = fetcher.items[id];
    if (!item) return null as any;
    return {
      label: item.name,
      value: item.id,
    };
  };
  return (
    <AsyncPaginatedSelect
      fetcher={officeStore.f}
      itemIdToOption={idToOpt}
      value={props.value}
      onChange={props.onChange}
      selectProps={{
        isMulti: true,
        ...(props.selectProps || {}),
      }}
    />
  );
});

export default OfficeSelect;
